import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "config/api";
import { EndGameRequest, StartGameRequest } from "interfaces/requests/Sessions";

const BASE_URL = "/sessions";

export const startSession = createAsyncThunk(
  "sessions/start",
  async (configId: string) => {
    try {
      const response = await axios.post(`${BASE_URL}/${configId}`);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - startSession ->", error);
      throw new Error(error.message);
    }
  },
);

export const startGame = createAsyncThunk(
  "sessions/start-game",
  async (request: StartGameRequest) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/startgame/${request.sessionId}`,
      );
      return response.data.data;
    } catch (error: any) {
      console.log("Error - startGame ->", error);
      throw new Error(error.message);
    }
  },
);

export const endGame = createAsyncThunk(
  "sessions/end-game",
  async (request: EndGameRequest) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/endgame/${request.sessionId}?cancelSession=${!!request.cancelSession}`,
      );
      return response.data.data;
    } catch (error: any) {
      console.log("Error - endGame ->", error);
      throw new Error(error.message);
    }
  },
);

export const forcedEndGame = createAsyncThunk(
  "sessions/forced-end-game",
  async (request: EndGameRequest) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/forcedendgame/${request.sessionId}`,
      );
      console.log("response: ", response);
    } catch (error: any) {
      console.log("Error - forcedEndGame ->", error);
      throw new Error(error.message);
    }
  },
);

export const getSessions = createAsyncThunk(
  "sessions/get-sessions",
  async () => {
    try {
      const response = await axios.get(`${BASE_URL}`);
      return response.data.data;
    } catch (error: any) {
      console.log("Error - getCurrentSession ->", error);
      throw new Error(error.message);
    }
  },
);

export const getCurrentSession = createAsyncThunk(
  "sessions/get-current-session",
  async () => {
    try {
      const response = await axios.get(`${BASE_URL}/`);
      return response.data.data[0];
    } catch (error: any) {
      console.log("Error - getCurrentSession ->", error);
      throw new Error(error.message);
    }
  },
);

export const getSessionUpdates = createAsyncThunk(
  "sessions/get-session-updates",
  async (sessionIds: string[]) => {
    try {
      const response = await axios.get(`${BASE_URL}/updates`, {
        params: { ids: sessionIds },
      });
      return response.data;
    } catch (error: any) {
      throw new Error(error.message);
    }
  },
);
